module.exports = __webpack_public_path__ + "img/UAE-Portrait-english.d768f9de.jpg";